import { fromJS } from 'immutable';
import { composeModules } from 'holocron';
import {
  HOTELS_TAB,
  TAB_TO_MODULE_NAME,
} from './constants/linesOfBusinessConstants';

export const SET_SELECTED_TAB = 'modules/axp-travel-home-search/SET_SELECTED_TAB';
export const SET_XS_TAB_OPEN = 'modules/axp-travel-home-search/SET_XS_TAB_OPEN';
export const SET_CLEAR_VISIBLE = 'modules/axp-travel-home-search/SET_CLEAR_VISIBLE';

export const initialState = fromJS({
  tabSelected: HOTELS_TAB,
  isXsTabOpen: false,
  isClearVisible: true,
});

// eslint-disable-next-line default-param-last -- this cannot be changed
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_TAB: {
      return state.merge({ tabSelected: action.payload });
    }
    case SET_XS_TAB_OPEN: {
      return state.merge({ isXsTabOpen: action.payload });
    }
    case SET_CLEAR_VISIBLE: {
      return state.merge({ isClearVisible: action.payload });
    }
    default:
      return fromJS(state);
  }
}

export function setSelectedTab(tab) {
  return async (dispatch) => {
    dispatch({ type: SET_SELECTED_TAB, payload: tab });
    await dispatch(composeModules(
      [
        { name: TAB_TO_MODULE_NAME[tab] },
      ]));
  };
}

export const setXsTabOpen = (isOpen) => ({
  type: SET_XS_TAB_OPEN,
  payload: isOpen,
});

export const setClearVisible = (isVisible) => ({
  type: SET_CLEAR_VISIBLE,
  payload: isVisible,
});

export const resetRequest = (lineOfBusiness) => ({
  type: `modules/axp-travel-search-${lineOfBusiness}/RESET_REQUEST`,
});
